/** Pomocniki do rozpoznawania i osadzania materiałów medialnych. */

export function youtubeId(url?: string): string | undefined {
  if (!url) return undefined;
  return (
    url.match(/[?&]v=([\w-]{6,})/)?.[1] ??
    url.match(/youtu\.be\/([\w-]{6,})/)?.[1] ??
    url.match(/youtube(?:-nocookie)?\.com\/embed\/([\w-]{6,})/)?.[1]
  );
}

export function spotifyEpisodeId(url?: string): string | undefined {
  if (!url) return undefined;
  return url.match(/open\.spotify\.com\/episode\/([\w-]+)/)?.[1];
}

/** Miniatura materiału: kadr z YouTube albo brak (wtedy pokazujemy logo). */
export function mediaThumbnail(url?: string): string | undefined {
  const id = youtubeId(url);
  return id ? `https://i.ytimg.com/vi/${id}/hqdefault.jpg` : undefined;
}

/** Adres do osadzenia w oknie modalnym; undefined = materiał otwieramy w nowej karcie. */
export function embedUrl(url?: string): string | undefined {
  const yt = youtubeId(url);
  if (yt) return `https://www.youtube-nocookie.com/embed/${yt}?autoplay=1`;
  const sp = spotifyEpisodeId(url);
  if (sp) return `https://open.spotify.com/embed/episode/${sp}?theme=0`;
  return undefined;
}

export const isEmbeddable = (url?: string) => Boolean(embedUrl(url));

/** Materiał wideo (także taki, którego nie da się osadzić, np. serwisy telewizyjne). */
export function isVideo(url?: string): boolean {
  if (!url) return false;
  return /youtube\.com|youtu\.be|\/wideo|\/video/i.test(url);
}
